module.exports = __webpack_public_path__ + "static/img/18.c2695d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/18.png
// module id = NrJ4
// module chunks = 2